import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  GoogleAuthProvider,
  User,
  createUserWithEmailAndPassword,
  deleteUser,
  getRedirectResult,
  sendEmailVerification,
  signInWithEmailAndPassword,
  signInWithPopup,
  signOut,
  updatePassword,
} from 'firebase/auth';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { auth, db } from '../../firebase/Firebase';
import { IProfile } from '../../interfaces/Types';
import { setLoggedIn, setProfile, setUser } from '../slices/authSlice';

export const createMyUser = createAsyncThunk('auth/create', async (action: any) => {
  await createUserWithEmailAndPassword(auth, action.email, action.password).then((res) => {
    sendEmailVerification(res.user);
  });
});

export const deleteMyUser = createAsyncThunk('auth/delete', async (action: any, thunkAPI: any) => {
  const { user } = thunkAPI.getState().auth;
  if (user) {
    deleteUser(user).catch((error) => {
      console.error(error);
    });
    logout(undefined);
  }
});

export const changeMyPassword = createAsyncThunk('auth/pw/update', async (action: any, thunkAPI: any) => {
  const { user } = thunkAPI.getState().auth;
  if (user) {
    updatePassword(user, action).catch((error) => {
      console.error(error);
    });
  }
});

export const signIn = createAsyncThunk('auth/signIn/pw', async (action: any) => {
  await signInWithEmailAndPassword(auth, action.email, action.password);
});

export const googleSignIn = createAsyncThunk('auth/signIn/google', async (action: any, thunkAPI: any) => {
  await signInWithPopup(auth, new GoogleAuthProvider());
  getRedirectResult(auth)
    .then((result) => {
      if (result) {
        // This gives you a Google Access Token. You can use it to access Google APIs.
        const credential = GoogleAuthProvider.credentialFromResult(result);
        if (credential) {
          credential.accessToken;
          // The signed-in user info.
          thunkAPI.dispatch(setUser({ ...result.user }));
        }
      }
    })
    .catch((error) => {
      // Handle Errors here.
      const errorCode = error.code;
      const errorMessage = error.message;
      // The email of the user's account used.
      const email = error.customData.email;
      console.log(email);
      // The AuthCredential type that was used.
      const credential = GoogleAuthProvider.credentialFromError(error);
      console.error(credential + ' (' + errorCode + ') ' + errorMessage);
    });
});

export const logout = createAsyncThunk('auth/logout', async (action: any, thunkAPI: any) => {
  await signOut(auth)
    .then(() => {
      thunkAPI.dispatch(setUser({} as User));
      thunkAPI.dispatch(setLoggedIn(false));
    })
    .catch((error) => {
      console.log(error);
    });
});

export const loadProfile = createAsyncThunk('auth/profile/load', async (action: any, thunkAPI: any) => {
  const { user } = thunkAPI.getState().auth;
  if (user?.uid) {
    const docRef = doc(db, `profiles/${user.uid}`);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      thunkAPI.dispatch(setProfile(docSnap.data() as IProfile));
      thunkAPI.dispatch(setLoggedIn(true));
    } else {
      thunkAPI.dispatch(createInitialProfile(undefined));
    }
  }
});

export const createInitialProfile = createAsyncThunk('auth/profile/create', async (action: any, thunkAPI: any) => {
  const { user } = thunkAPI.getState().auth;

  if (user?.uid) {
    const data = {
      availabletime: 480,
      workingtime: 1920,
      workingdays: {
        monday: true,
        tuesday: true,
        wednesday: true,
        thursday: true,
        friday: true,
        saturday: false,
        sunday: false,
      },
      holidays: 24,
      state: 'Baden-Württemberg',
    };
    setDoc(doc(db, `profiles/${user.uid}`), data)
      .then(() => {
        thunkAPI.dispatch(setProfile(data as IProfile));
        thunkAPI.dispatch(setLoggedIn(true));
      })
      .catch((error) => {
        console.log(error);
      });
  }
});

export const updateProfile = createAsyncThunk('auth/profile/update', async (action: any, thunkAPI: any) => {
  const { user } = thunkAPI.getState().auth;
  const profile = action;
  if (user?.uid) {
    setDoc(doc(db, `profiles/${user.uid}`), {
      availabletime: profile.availabletime,
      workingtime: profile.workingtime,
      workingdays: {
        monday: profile.workingdays.monday,
        tuesday: profile.workingdays.tuesday,
        wednesday: profile.workingdays.wednesday,
        thursday: profile.workingdays.thursday,
        friday: profile.workingdays.friday,
        saturday: profile.workingdays.saturday,
        sunday: profile.workingdays.sunday,
      },
      holidays: profile.holidays as number,
      state: profile.state,
    })
      .then(() => {
        thunkAPI.dispatch(setProfile(profile as IProfile));
      })
      .catch((error) => {
        console.log(error);
      });
  }
});
